/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */

import { randomTransactionId } from "redsys-easy";

export default {
  methods: {
    onApplePayLoaded() {
      if (this._applePayAvailable()) {
        this.applePayUiController().displayApplePayButton();
      } else {
        this.applePayUiController().displayErrorMessage();
      }
    },
    applePayUiController() {
      let DOMStrings = {
        appleButton: "ckoApplePay",
        errorMessage: "ckoApplePayError"
      };
      return {
        DOMStrings,
        displayApplePayButton: function() {
          document.getElementById(DOMStrings.appleButton).style.display =
            "block";
          document.getElementById("ckoApplePay").click();
        },
        displayErrorMessage: function() {
          document.getElementById(DOMStrings.errorMessage).style.display =
            "none";
        }
      };
    },
    _applePayAvailable() {
      return window.ApplePaySession && ApplePaySession.canMakePayments();
    },
    _setButtonClickListener() {
      this._startApplePaySession({
        currencyCode: "EUR",
        countryCode: "ES",
        merchantCapabilities: [
          "supports3DS",
          "supportsDebit",
          "supportsCredit"
        ],
        supportedNetworks: [
          "visa",
          "masterCard",
          "amex",
          "discover",
          "cartesBancaires",
          "chinaUnionPay",
          "eftpos",
          "electron",
          "elo",
          "interac",
          "jcb",
          "mada",
          "maestro",
          "privateLabel",
          "vPay"
        ],
        total: {
          label: process.env.VUE_APP_PROJECT_NAME,
          amount: parseFloat(this.totalPrice).toString(),
          type: "final"
        }
      });
    },

    _startApplePaySession(config) {
      try {
        let applePaySession = new ApplePaySession(6, config);

        this._handleApplePayEvents(applePaySession);
      } catch (error) {
        console.error(error);
      }
    },
    _handleApplePayEvents(applePaySession) {
      applePaySession.onvalidatemerchant = event => {
        this._validateApplePaySession()
          .then(merchantSession => {
            try {
              applePaySession.completeMerchantValidation(merchantSession);
            } catch (err) {
              alert("error while completing merchant validation : " + err);
            }
          })
          .catch(err => {
            console.error(err);
            alert("apple pay seeson not getting" + err);
          });
      };

      // This method is the most important method. It gets triggered after teh user has
      // confirmed the transaction with the Touch ID or Face ID. Besides getting all the
      // details about the customer you also get the Apple Pay payload needed to perform
      // a payment.
      applePaySession.onpaymentauthorized = async event => {
        let token = JSON.stringify(event.payment.token.paymentData);
        let orderId = randomTransactionId();

        // init payment to check payment success later
        let paymentId = await this.initPayment({
          orders: this.cart,
          paymentMethod: "applepay",
          amount: parseFloat(this.totalPrice),
          orderAmount: parseFloat(this.totalPrice),
          paymentType: this.dividePayment,
          externalPaymentId: orderId
        });

        this._performTransaction(token, orderId)
          .then(outcome => {
            if (outcome.Ds_MerchantParameters) {
              let treatSuccessResult = this.processNotificationParameters(
                outcome.Ds_MerchantParameters
              );
              console.log("treatSuccessResult:::", treatSuccessResult);

              if (treatSuccessResult.Ds_Response !== undefined) {
                if (
                  !this.checkCorrectDSResponse(treatSuccessResult.Ds_Response)
                ) {
                  this.showErrorMessage(treatSuccessResult.Ds_Response);
                  return null;
                }
              }

              applePaySession.completePayment(applePaySession.STATUS_SUCCESS);
              localStorage.setItem(
                "missingAmountToPay",
                parseFloat(this.unpaidTotalPrice).toFixed(2)
              );
              localStorage.setItem("amountToBePaid", this.totalPrice);
              localStorage.setItem("isPaid", "true");
              if (this.dividePayment === "todo") {
                localStorage.setItem("payment_type", "todo");
              } else if (this.dividePayment === "amount") {
                localStorage.setItem("payment_type", "amount");
              } else {
                localStorage.setItem("payment_type", "product");
              }

              this.$router.push({
                path: "/success-applepay",
                query: {
                  externalId: treatSuccessResult.Ds_Order,
                  p_id: paymentId
                }
              });
            } else {
              applePaySession.completePayment(applePaySession.STATUS_FAILURE);
              if (outcome.errorCode !== undefined) {
                this.showErrorMessage(
                  this.getRedsysErrorMessage(outcome.errorCode)
                );
              }
            }
          })
          .catch(err => {
            console.error(err);
            this.showErrorMessage(
              "Applepay perform transaction err: " + JSON.stringify(err)
            );
          });
      };

      applePaySession.oncancel = event => {
        console.log(event);
      };

      applePaySession.begin();
    },
    _validateApplePaySession() {
      return new Promise((resolve, reject) => {
        let sessonURL =
          "https://apple-pay-gateway.apple.com/paymentservices/paymentSession";

        this.$api.admin
          .validateSession({
            sessonURL: sessonURL
          })
          .then(response => {
            resolve(response);
          })
          .catch(err => {
            reject(err);
            console.log("validate err:::" + JSON.stringify(err));
            this.showErrorMessage(
              "Applepay validate err:" + JSON.stringify(err)
            );
          });
      });
    },
    _performTransaction(payment, orderId) {
      return new Promise((resolve, reject) => {
        this.$api.admin
          .pay({
            xPay: payment,
            amount: parseFloat(this.totalPrice * 100).toString(),
            orderId: orderId
          })
          .then(response => {
            resolve(response);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  }
};
